import { type HttpRequestOptions, HttpService } from '@ad-lucy/utils';
import { useCallback, useState } from 'react';

export type Get<ResponseType> = (
  url: string,
  options?: Omit<HttpRequestOptions, 'signal'>,
) => Promise<ResponseType>;

export interface Request<ResponseType> {
  loading: boolean;
  get: Get<ResponseType>;
  error: Error | undefined;
}

export function useFetch<ResponseType>(loadingStateOnInit = false): Request<ResponseType> {
  const [loading, setLoading] = useState(loadingStateOnInit);
  const [error, setError] = useState<Error>();

  const get = useCallback<Get<ResponseType>>((url, options) => {
    setLoading(true);
    const request = HttpService.get<ResponseType>(url, {
      ...options,
    });
    request
      .catch((err: undefined | string | Error) => {
        setError(err instanceof Error ? err : new Error(err));
      })
      .finally(() => {
        setLoading(false);
      });

    return request;
  }, []);

  return {
    loading,
    error,
    get,
  };
}
